import React from 'react';

import { InboxSidebarItemData } from 'src/legacy/components/Inbox';

interface InboxPageContextType {
  selectedNotification: InboxSidebarItemData | null;
  setSelectedNotification: (notification: InboxSidebarItemData | null) => void;
  pagesToLoad: number;
  hasMoreNotifications: boolean;
  isLoadingMoreNotifications: boolean;
  loadMoreNotifications: () => void;
}

export const InboxPageContext = React.createContext<InboxPageContextType>({
  selectedNotification: null,
  setSelectedNotification: (notification: InboxSidebarItemData | null) => {
    console.info('setSelectedNotification not provided', notification);
  },
  pagesToLoad: 1,
  hasMoreNotifications: false,
  isLoadingMoreNotifications: false,
  loadMoreNotifications: () => {
    console.info('loadMoreNotifications not provided');
  },
});
